import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    IBuyerRequestSubsidyInfoClient,
} from 'interfaceAdapter/gatewaySchemas/IBuyerRequestSubsidyInfoClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/buyer/request_subsidy_info`;

export class BuyerRequestSubsidyInfoClient implements IBuyerRequestSubsidyInfoClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-B': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({});

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
